export default __webpack_public_path__ + "static/media/slider_img1.bb252e92.png";